import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { PushPipe } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { selectHasHelpfulPermission } from '@ninety/platform/state';
import { FilterBarActions } from '@ninety/web/pages/shared/layouts';

import { AddHelpfulComponent } from './components/add-helpful/add-helpful.component';
import { EmailSuppressionListComponent } from './components/email-suppression-list/email-suppression-list.component';
import { ExportCsvComponent } from './components/export-csv/export-csv.component';
import { HardDeleteCompanyComponent } from './components/hard-delete-company/hard-delete-company.component';

@Component({
  selector: 'ninety-helpful',
  templateUrl: './helpful.component.html',
  styleUrls: ['./helpful.component.scss'],
  standalone: true,
  imports: [
    MatTabGroup,
    MatTab,
    AddHelpfulComponent,
    ExportCsvComponent,
    EmailSuppressionListComponent,
    HardDeleteCompanyComponent,
    PushPipe,
  ],
})
export class HelpfulComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);

  protected readonly canHardDeleteCompany$ = this.store.select(selectHasHelpfulPermission('hardDeleteCompany'));
  protected readonly canExportDirectoryCsv$ = this.store.select(selectHasHelpfulPermission('companies'));

  ngOnInit() {
    this.store.dispatch(FilterBarActions.hide());
  }

  ngOnDestroy() {
    this.store.dispatch(FilterBarActions.show());
  }
}
